import {
    ADD_ADMIN_REQUEST,
    ADD_PROVIDER_REQUEST,
    APPROVE_ATTENTION_REQUEST,
    CREATE_ATTENTION_REQUEST,
    SEND_QUOTE_EMAIL_REQUEST,
    DELETE_ATTENTION_REQUEST,
    DELETE_ADMIN_REQUEST,
    DELETE_PROVIDER_REQUEST,
    GET_AFFILIATE_REQUEST,
    GET_ALL_ATTENTIONS_REQUEST,
    GET_ALL_MEDICAL_SERVICES_REQUEST,
    GET_BRANCHES_PROVIDERS_REQUEST,
    GET_BRANCHES_REQUEST,
    GET_MEDICAL_SERVICES_REQUEST,
    GET_PLANS_REQUEST,
    GET_PROVIDERS_ME_REQUEST,
    GET_PROVIDERS_REQUEST,
    GET_REGIONS_REQUEST,
    GET_STATES_REQUEST,
    GET_USERS_REQUEST,
    PUT_ADMIN_REQUEST,
    PUT_CHANGE_PASSWORD_REQUEST,
    PUT_PROVIDER_REQUEST,
    SELECT_SELF,
    BULK_INSERT,
    GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST,
    GET_AMOUNT_LIST_REQUEST,
    GET_ALL_AMOUNTS_DOWNLOAD_REQUEST,
} from './home.actions';
import {services} from './home.services';
import actions from '../redux/actions';
import {toast} from 'react-toastify';

const affiliateRetryTime = 180000;

const formatPositiveDownloadAmount = (amount) => {
    if (typeof amount === 'string' && amount.trim().startsWith('$')) {
        return amount;
    }

    const numericAmount = Number(amount);

    if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
        return '-';
    }

    return '$ ' + numericAmount.toLocaleString('es-ES', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};

const isAmountHidden = (response) =>
    response?.hideAmounts === true ||
    response?.hideAmounts === 'true' ||
    response?.flagAmount === true ||
    response?.flagAmount === 'true' ||
    response?.flagAmount === 1 ||
    response?.flagAmount === '1';

const formatAttentionAmount = (amount, hideAmounts) => {
    if (hideAmounts || !amount || amount <= 0) {
        return '-';
    }
    return '$ ' + amount.toLocaleString('es-ES', {minimumFractionDigits: 0, maximumFractionDigits: 2});
};

const homeMiddleware = ({dispatch, getState}) => (next) => (action) => {
    next(action);
    switch (action.type) {
        case GET_STATES_REQUEST:
            services
                .getStates().then((res) => {
                dispatch(actions.home.getStatesResponse(res));
            })
                .catch((error) => {
                    dispatch(actions.home.getStatesResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_REGIONS_REQUEST:
            services
                .getRegions().then((res) => {
                dispatch(actions.home.getRegionsResponse(res));
            })
                .catch((error) => {
                    dispatch(actions.home.getRegionsResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_BRANCHES_REQUEST:
            services
                .getBranches().then((res) => {
                dispatch(actions.home.getBranchesResponse(res));
            })
                .catch((error) => {
                    dispatch(actions.home.getBranchesResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_BRANCHES_PROVIDERS_REQUEST:
            services
                .getBranchesProviders(action.id).then((res) => {
                dispatch(actions.home.getBranchesProvidersResponse(res));
            })
                .catch((error) => {
                    dispatch(actions.home.getBranchesProvidersResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_PROVIDERS_REQUEST:
            services
                .getProviders(getState().home.providerListConfig).then((res) => {
                res.response.result = res.response.result.map((x) => {
                    x.salesforceProviderName = x.salesforceProviderId === 'a1l2K000005fIfrQAE' ? '-' : x.salesforceProviderName;
                    return x;
                });
                dispatch(actions.home.getProvidersResponse(res.response));
            })
                .catch((error) => {
                    dispatch(actions.home.getProvidersResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_PROVIDERS_ME_REQUEST:
            services
                .getProvidersMe(getState().home.providerListConfig).then((res) => {
                res.response.result = res.response.result.map((x) => {
                    x.salesforceProviderName = x.salesforceProviderId === 'a1l2K000005fIfrQAE' ? '-' : x.salesforceProviderName;
                    return x;
                });
                dispatch(actions.home.getProvidersMeResponse(res.response));
            })
                .catch((error) => {
                    dispatch(actions.home.getProvidersMeResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_USERS_REQUEST:
            services
                .getUsers(getState().home.adminListConfig).then((res) => {
                dispatch(actions.home.getUsersResponse(res.response));
            })
                .catch((error) => {
                    dispatch(actions.home.getUsersResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case ADD_PROVIDER_REQUEST:
            toast.info('Creando Usuario de Prestador');
            services
                .addProvider(action.body).then((res) => {
                dispatch(actions.home.addProviderResponse(res.response));

                toast.success('Nuevo Usuario Prestador Creado');
            })
                .catch((error) => {
                    dispatch(actions.home.addProviderResponseError(error));
                    if (error?.data?.error === 'Provider Admin already exists for that role') {
                        toast.error('Ya existe un usuario administrador para ese prestador', {autoClose: 10000});
                    } else {
                        toast.error('Ha ocurrido un error');
                    }
                });
            break;
        case PUT_PROVIDER_REQUEST:
            services
                .putProvider(action.body).then((res) => {
                dispatch(actions.home.putProviderResponse(res.response));

                toast.success('Usuario de Prestador Modificado');
            })
                .catch((error) => {
                    dispatch(actions.home.putProviderResponseError(error));
                    if (error?.data?.error === 'Provider Admin already exists for that role') {
                        toast.error('Ya existe un usuario administrador para ese prestador', {autoClose: 10000});
                    } else {
                        toast.error('Ha ocurrido un error');
                    }
                });
            break;
        case DELETE_PROVIDER_REQUEST:
            services
                .deleteProvider(action.id, action.providerType)
                .then((res) => {
                    dispatch(actions.home.deleteProviderResponse(res));

                    toast.success('Usuario de Prestador Eliminado');

                    if (getState().login?.userInfo?.role?.name === 'PROVIDER_ADMIN') {
                        dispatch(actions.home.getProvidersMeRequest());
                    } else {
                        dispatch(actions.home.getProvidersRequest());
                    }
                })
                .catch((error) => {
                    dispatch(actions.home.deleteProviderResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case DELETE_ADMIN_REQUEST:
            services
                .deleteAdmin(action.id)
                .then((res) => {
                    dispatch(actions.home.deleteAdminResponse(res));

                    toast.success('Usuario administrador eliminado');
                    dispatch(actions.home.getUsersRequest());
                })
                .catch((error) => {
                    dispatch(actions.home.deleteAdminResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case ADD_ADMIN_REQUEST:
            toast.info('Creando Usuario Administrador');
            services
                .addAdmin(action.body).then((res) => {
                dispatch(actions.home.addAdminResponse(res.response));
            })
                .catch((error) => {
                    dispatch(actions.home.addAdminResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case PUT_ADMIN_REQUEST:
            services
                .putAdmin(action.body).then((res) => {
                dispatch(actions.home.putAdminResponse(res.response));
                toast.success('Usuario modificado');
            })
                .catch((error) => {
                    dispatch(actions.home.putAdminResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case PUT_CHANGE_PASSWORD_REQUEST:
            services
                .putChangePassword(action.body).then((res) => {
                dispatch(actions.home.putChangePasswordResponse(res.response));
                toast.success('Contraseña Modificada');
            })
                .catch((error) => {
                    dispatch(actions.home.putChangePasswordResponseError(error));
                    if (error?.data?.error === 'Invalid current password') {
                        toast.error('Contraseña actual incorrecta', {autoClose: 8000});
                    } else {
                        toast.error('Ha ocurrido un error');
                    }
                });
            break;
        case SELECT_SELF:

            const roleName = getState().login.userInfo.role.name;

            if (roleName === 'ADMIN') {
                services
                    .getSelfAdmin().then((res) => {
                    dispatch(actions.home.selectSelfResponse(res.response));
                    dispatch(actions.home.setAdminSelected(res.response));
                })
                    .catch((error) => {
                        dispatch(actions.home.selectSelfResponseError(error));
                        toast.error('Ha ocurrido un error');
                    });
            } else if (roleName === 'PROVIDER_ADMIN' || roleName === 'PROVIDER_USER' ||
                roleName === 'PROVIDER_USER_QUOTER' || roleName === 'PROVIDER_USER_VIEWER' ||
                roleName === 'DEVELOPER') {
                services
                    .getSelfProvider().then((res) => {
                    dispatch(actions.home.selectSelfResponse(res));
                    dispatch(actions.home.setProviderSelected(res));
                })
                    .catch((error) => {
                        dispatch(actions.home.selectSelfResponseError(error));
                        toast.error('Ha ocurrido un error');
                    });
            }
            break;
        case GET_AFFILIATE_REQUEST:
            if ((localStorage['affiliateRetryTime'] && (localStorage['affiliateRetryTime'] - Date.now()) > 0) &&
                (localStorage['affiliateRetry'] && localStorage['affiliateRetry'] > 4)) {
                toast.error('Número máximo de intentos alcanzado');
            } else {
                if (!(localStorage['affiliateRetryTime'] && (localStorage['affiliateRetryTime'] - Date.now()) > 0)) {
                    localStorage.removeItem('affiliateRetry');
                    localStorage.removeItem('affiliateRetryTime');
                }
                services
                    .getAffiliate(action.document, action.documentType).then((res) => {
                    if (res.affiliates === null) {
                        localStorage['affiliateRetry'] = localStorage['affiliateRetry'] ? parseInt(localStorage['affiliateRetry']) + 1 : 1;
                        localStorage['affiliateRetryTime'] = Date.now() + affiliateRetryTime;
                    } else {
                        localStorage.removeItem('affiliateRetry');
                        localStorage.removeItem('affiliateRetryTime');
                    }
                    dispatch(actions.home.getAffiliateResponse(res));
                })
                    .catch((error) => {
                        dispatch(actions.home.getAffiliateResponseError(error));
                        toast.error('Ha ocurrido un error');
                    });
            }
            break;
        case GET_PLANS_REQUEST:
            services
                .getPlans().then((res) => {
                dispatch(actions.home.getPlansResponse(res.response));
            })
                .catch((error) => {
                    dispatch(actions.home.getPlansResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_MEDICAL_SERVICES_REQUEST:
            services
                .getMedicalServices(action.plans, getState().home.medicalServicesListConfig).then((res) => {
                const resAux = res.result.map((x) => {
                    const modality = (x.tariff !== 'SI' && x.needsToPay === 0) ?
                        'Cubierto' : (x.tariff !== 'SI' && x.needsToPay !== 0) ? 'Con Copago: $' + x.needsToPay : 'Arancel Preferencial';
                    x.modality = modality;
                    x.medicalServiceDescription = x.medicalServiceDescription?.toUpperCase();
                    x.medicalServiceName = x.medicalServiceName?.toUpperCase();
                    return x;
                });
                resAux.totalCount = res.totalCount;
                resAux.page = res.page;
                dispatch(actions.home.getMedicalServicesResponse(resAux));
            })
                .catch((error) => {
                    dispatch(actions.home.getMedicalServicesResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_ALL_MEDICAL_SERVICES_REQUEST:
            const state = getState();
            services
                .getAllMedicalServices(state.home.allMedicalServicesConfig, state.home.attentionForCreate.salesforceBranchId).then((res) => {
                const resAux = {};
                resAux.results = res.result.map((x) => {
                    x.medicalServiceName = x.medicalServiceName.toUpperCase();
                    x.checked = getState().home.attentionsSelected.some((att) => att.medicalServiceId === x.medicalServiceId);
                    return x;
                });
                resAux.totalCount = res.totalCount;
                resAux.page = res.page;
                dispatch(actions.home.getAllMedicalServicesResponse(resAux));
            })
                .catch((error) => {
                    dispatch(actions.home.getAllMedicalServicesResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_ALL_ATTENTIONS_REQUEST:
            services
                .getAllAttentions(getState().home.attentionsListConfig).then((res) => {
                const hideAmounts = isAmountHidden(res);
                // Check if response is grouped (has groups with attentions array)
                const isGrouped = res.result && res.result.length > 0 && res.result[0].attentions;

                if (isGrouped) {
                    // Handle grouped response
                    const processedGroups = res.result.map((group) => {
                        // Process each attention in the group
                        const processedAttentions = group.attentions.map((attention) => {
                            attention.amountPaid = formatAttentionAmount(attention.amountPaid, hideAmounts);
                            attention.planName = attention.planName ? attention.planName : '-';
                            attention.numbers = 'DNI: ' + attention.affiliateDocument + ' - Credencial: ' + attention.affiliateNumber;
                            attention.medicalServiceName = attention.medicalServiceName.toUpperCase();
                            attention.providerName = attention.providerId === 'a1l2K000005fIfrQAE' ? '-' : attention.providerName;
                            return attention;
                        });

                        return {
                            ...group,
                            attentions: processedAttentions,
                            totalPaidAmountFormatted: formatAttentionAmount(group.totalPaidAmount, hideAmounts),
                        };
                    });

                    const resAux = {
                        result: processedGroups,
                        totalCount: res.totalCount,
                        page: res.page,
                        isGrouped: true,
                        hideAmounts,
                    };
                    dispatch(actions.home.getAllAttentionsResponse(resAux));
                } else {
                    // Handle non-grouped response (original format)
                    const resAux = res.result.map((x) => {
                        x.amountPaid = formatAttentionAmount(x.amountPaid, hideAmounts);
                        x.planName = x.planName ? x.planName : '-';
                        x.numbers = 'DNI: ' + x.affiliateDocument + ' - Credencial: ' + x.affiliateNumber;
                        x.medicalServiceName = x.medicalServiceName.toUpperCase();
                        x.providerName = x.providerId === 'a1l2K000005fIfrQAE' ? '-' : x.providerName;
                        return x;
                    });
                    resAux.totalCount = res.totalCount;
                    resAux.page = res.page;
                    resAux.isGrouped = false;
                    resAux.hideAmounts = hideAmounts;
                    dispatch(actions.home.getAllAttentionsResponse(resAux));
                }
            })
                .catch((error) => {
                    dispatch(actions.home.getAllAttentionsResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_ALL_ATTENTIONS_DOWNLOAD_REQUEST:
            services
                .getAllAttentionsToDownload(getState().home.attentionsListConfig).then((res) => {
                const hideAmounts = isAmountHidden(res);
                const resAux = res.result.map((x) => {
                    x.amountPaid = hideAmounts ? '-' : formatPositiveDownloadAmount(x.amountPaid);
                    x.netAmount = hideAmounts ? '-' : formatPositiveDownloadAmount(x.netAmount);
                    x.copago = hideAmounts ? '-' : formatPositiveDownloadAmount(x.copago);
                    x.planName = x.planName ? x.planName : '-';
                    x.daysToPay = x.daysToPay ? x.daysToPay : '0';
                    x.medicalServiceCategory = x.medicalServiceCategory ? x.medicalServiceCategory : '-';
                    x.medicalServiceDescription = x.medicalServiceDescription ? x.medicalServiceDescription : '-';
                    // eslint-disable-next-line max-len
                    x.numbers = 'DNI: ' + x.affiliateDocument ? x.affiliateDocument : '-' + ' - Credencial: ' + x.affiliateNumber ? x.affiliateNumber : '-';
                    x.medicalServiceName = x.medicalServiceName.toUpperCase();
                    x.providerName = x.providerId === 'a1l2K000005fIfrQAE' ? '-' : x.providerName;
                    return x;
                });
                resAux.totalCount = res.totalCount;
                resAux.hideAmounts = hideAmounts;
                dispatch(actions.home.getAllAttentionsDownloadResponse(resAux));
            })
                .catch((error) => {
                    dispatch(actions.home.getAllAttentionsResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case APPROVE_ATTENTION_REQUEST:
            services
                .approveAttention(action.body).then((res) => {
                const responsePayload = res?.response || res;
                const coveredByProvider = responsePayload.coveredByProvider?.map((att) => {
                    att.needInputAmount = att?.feeStatus && att.feeStatus === 'feeNeeded';
                    att.medicalServiceName = att.medicalServiceName.toUpperCase();
                    return att;
                });
                const notCoveredByProvider = responsePayload.notCoveredByProvider?.map((att) => {
                    return {...att, medicalServiceName: att.medicalServiceName.toUpperCase()};
                });
                const flagAmount = responsePayload.flagAmount === true ||
                    responsePayload.flagAmount === 'true' ||
                    responsePayload.flagAmount === 1 ||
                    responsePayload.flagAmount === '1';
                const resAux = {
                    coveredByProvider: coveredByProvider,
                    notCoveredByProvider: notCoveredByProvider,
                    flagAmount: flagAmount,
                };
                if (responsePayload.notCoveredByProvider) {
                    resAux.errorMessage = responsePayload.notCoveredByProvider.length > 1 ?
                        'Las siguientes atenciones no estan disponibles en esta sede:' :
                        'La siguiente atención no esta disponible en esta sede:';
                }
                dispatch(actions.home.approveAttentionResponse(resAux));
            })
                .catch((error) => {
                    if (error.data.code === 'PROVIDER_BRANCH_NOT_SUPPORTS_SERVICE') {
                        error.data.message = 'La/s siguientes atenciones no estan disponibles en este prestador:';
                        const aux = error.data.payload.medicalServices?.map((x, index) => {
                            error.data.message = error.data.message + ' ' + x.medicalServiceName;
                            if (index !== error.data.payload.medicalServices.length - 1) {
                                error.data.message = error.data.message + ',';
                            }
                        });
                    } else {
                        error.data.message = 'Ha ocurrido un error';
                    }
                    dispatch(actions.home.approveAttentionResponseError(error.data));
                });
            break;
        case CREATE_ATTENTION_REQUEST:
            services
                .createAttention(action.body).then((res) => {
                dispatch(actions.home.createAttentionResponse(res));
            })
                .catch((error) => {
                    dispatch(actions.home.createAttentionResponseError(error.data.error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case SEND_QUOTE_EMAIL_REQUEST:
            services
                .sendQuoteEmail(action.body).then((res) => {
                dispatch(actions.home.sendQuoteEmailResponse(res));
                toast.success('Cotización enviada');
            })
                .catch((error) => {
                    dispatch(actions.home.sendQuoteEmailResponseError(error?.data?.error || true));
                    toast.error('No se pudo enviar la cotización');
                });
            break;
        case BULK_INSERT:
            services
                .bulkInsert(action.body).then((res) => {
                dispatch(actions.home.bulkInsertResponse(res));
                switch (res.status) {
                    case 'SUCCESS':
                        toast.success('Usuarios cargados correctamente', {autoClose: 10000});
                        break;
                    case 'SUCCESS_WITH_ERRORS':
                        toast.warning('Algunos usuarios cargados correctamente', {autoClose: 10000});
                        break;
                    case 'FAILED':
                        toast.warning('No se han creado nuevos usuarios', {autoClose: 10000});
                        break;
                    default:
                        toast.error('Ha ocurrido un error', {autoClose: 10000});
                        break;
                }
            })
                .catch((error) => {
                    dispatch(actions.home.bulkInsertResponseError(error.data));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case DELETE_ATTENTION_REQUEST:
            services
                .deleteAttention(action.body).then((res) => {
                dispatch(actions.home.deleteAttentionResponse(res));
                dispatch(actions.home.getAllAttentionsRequest());
            })
                .catch((error) => {
                    dispatch(actions.home.deleteAttentionResponseError(error?.data?.error));
                });
            break;
        case GET_AMOUNT_LIST_REQUEST:
            services
                .getAmountList(getState().home.amountListConfig).then((res) => {
                console.log('amountListRequest');
                dispatch(actions.home.getAmountListResponse(res.response));
            })
                .catch((error) => {
                    dispatch(actions.home.getAmountListResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case GET_ALL_AMOUNTS_DOWNLOAD_REQUEST:
            services
                .getAmountListToDownload(getState().home.amountListConfig).then((res) => {
                dispatch(actions.home.getAllAmountsToDownloadResponse(res.response.amounts));
            })
                .catch((error) => {
                    dispatch(actions.home.createAllAmountsToDownloadError(error.data.error));
                    toast.error('Ha ocurrido un error');
                });
        default:
            break;
    }
};

export default homeMiddleware;
